import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import Bugsnag from "@bugsnag/js";

@Component({
  selector: 'app-arc-gis-redirect',
  templateUrl: './arc-gis-redirect.component.html',
  styleUrls: ['./arc-gis-redirect.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArcGisRedirectComponent implements OnInit {

  // eslint-disable-next-line no-empty-function
  constructor(private _rout:Router, private route: ActivatedRoute, public globals: Globals,) { }

  ngOnInit() {
      const projectcode=localStorage.getItem('project_name');
      const accessToken=this._rout.url.match(/code=([^&]+)/);

      // Check if this is a bouwapp callback and has a redirect path
      // This allows Bouwapp integration initiated from /inbox to return to /inbox
      // instead of defaulting to /integraties (backward compatible)
      const bouwappRedirectPath = localStorage.getItem('bouwappRedirectPath');
      const driver = this.route.snapshot.paramMap.get('driver');

      if(projectcode){
        // If bouwapp callback and has redirect path, use it (e.g., when initiated from /inbox)
        if (driver === 'bouwapp' && bouwappRedirectPath) {
          // Preserve the code parameter for the callback handler on the target page
          const codeParam = accessToken && accessToken[1] ? `?code=${accessToken[1]}` : '';

          // Clean up the stored redirect path
          localStorage.removeItem('bouwappRedirectPath');
          localStorage.removeItem('bouwappInboxUrl');

          // Build redirect URL with project code and preserve code parameter
          const redirectUrl = `/${projectcode}${bouwappRedirectPath}${codeParam}`;
          window.location.href = redirectUrl;
          return;
        }

        // Default behavior for other integrations (ArcGIS, etc.) and Bouwapp without returnTo
        // This maintains backward compatibility: when returnTo is not set, behavior is unchanged
        if(accessToken && accessToken[1]){
          if(projectcode.includes('beheer')){
            localStorage.setItem('arcgisRedirect', `/${projectcode}/integraties?code=${accessToken[1]}`);
            window.location.href=`/${projectcode}/integraties?code=${accessToken[1]}`;
          }else{
            localStorage.setItem('arcgisRedirect', `/${projectcode}/instellingen/integraties?code=${accessToken[1]}`);
            window.location.href=`/${projectcode}/instellingen/integraties?code=${accessToken[1]}`;
          }
        }
      }else{
        localStorage.setItem('arcgisRedirect','/');
        window.location.href='/';
        Bugsnag.notify(JSON.stringify({
          message: 'Project Code is undefined',
        }));
      }
    }
}
